import { Button } from '@library/components/buttons';
import addIcon from '@library/assets/images/icons/add-white-icon.svg';
import { classNames } from '@library/utils';

export interface AddIconButtonProps {
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export const AddIconButton = ({
  className = '',
  disabled = false,
  label = '',
  onClick
}: AddIconButtonProps) => {
  return (
    <Button
      className={classNames(
        'bg-soFresh-110 border-soFresh-140 flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-solid text-[13px] font-medium',
        'hover:bg-soFresh-120',
        disabled ? 'cursor-not-allowed opacity-80' : 'cursor-pointer',
        className
      )}
      data-testid="AddIconButton"
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      <img
        className={(classNames('h-4 w-4 shrink-0'), label && 'mr-1')}
        src={addIcon}
        alt={label}
      />
      <span className={label ? 'mr-1' : ''}>{label}</span>
    </Button>
  );
};
